import { FormikProps } from 'formik';
import React, { useCallback } from 'react';
import { Optin } from '../../services/optinService';
import OptinList from './OptinList';

type RequiredFormikOptinListValues = {
  optins: Optin[];
};

type FormikOptinListProps<T extends RequiredFormikOptinListValues> = {
  formikProps: FormikProps<T>;
  loading?: boolean;
};

export const FormikOptinList = <T extends RequiredFormikOptinListValues>(
  formikOptInListProps: FormikOptinListProps<T>
) => {
  const { setFieldValue, values } = formikOptInListProps.formikProps;
  const onChange = useCallback(
    (optins: Optin[]) => {
      setFieldValue('optins', optins, false);
    },
    [setFieldValue]
  );

  return (
    <OptinList loading={formikOptInListProps.loading} optins={values.optins} onChange={onChange} />
  );
};
